@if (languageService.supportedLanguages$ | async; as supportedLanguages) {
	<div class="languages">
		@for (lang of supportedLanguages; track lang; let i = $index) {
			<button
				nz-button
				[nzType]="selectedLanguage == lang.code ? 'primary' : 'default'"
				(click)="selectLanguage(lang.code)"
				[class]="'bounce-in-' + i"
				(click)="selectLanguage(lang.code); $event.preventDefault()"
				[class.selected]="selectedLanguage == lang.code"
			>
				{{ lang.label }}
			</button>
		}
	</div>
}
